import React from 'react';

import './Inputs.scss';

export default class TextArea extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: null
        }
    }

    render() {
        let invalidClass = this.props.errors && this.props.errors > 0 ? 'invalid' : '';

        return (
            <textarea
                className={`a-input ${invalidClass}`}
                onChange={this.props.onChange}
                placeholder={this.props.placeholder}
                name={this.props.name}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Form/Inputs/TextArea.jsx